import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const SubsellerSection = Loadable(lazy(() => import('./SubsellerSection')));
const SubSellerList = Loadable(lazy(() => import('./SubSellerList')));
const ProductEditList = Loadable(
	lazy(() => import('../../form/EditProductForm'))
);

const SubSellerRoutes = [
	{
		path: '/subseller/add',
		element: <SubsellerSection />,
		auth: authRoles.admin,
	},
	{
		path: '/subseller/list',
		element: <SubSellerList />,
		auth: authRoles.admin,
	},
	{
		path: '/product/edit',
		element: <ProductEditList />,
		auth: authRoles.admin,
	},
];

export default SubSellerRoutes;
